import {ru, en, am} from '../../../lang/locale';

export default {
  data() {
    return {
      combined: [],
      ru: ru,
      am: am,
      en: en,
    };
  },
  methods: {
    openMobileTools(){
      return this.mobTools = !this.mobTools;
    },
    addEvents() {
      let tools = document.getElementsByClassName("name_tools");
      Array.prototype.slice.call(tools).forEach(element => {
        element.addEventListener("click", this.toogleTools);
      });

      var inputs = document.querySelectorAll(
        ".all_form_block .block .div_relative input"
      );

      var textareas = document.querySelectorAll(
        ".all_form_block .block .div_relative textarea"
      );

      this.combined = [].concat(
        Array.prototype.slice.call(inputs),
        Array.prototype.slice.call(textareas)
      );

      this.combined.forEach(element => {
        if (element.closest(".div_relative")) {
          if (element.closest(".div_relative").firstElementChild.tagName === "SPAN") {
            element.closest(".div_relative").firstElementChild.addEventListener('click', () => {
              element.select();
            });
          }
        }
        element.addEventListener("click", this.correctLabel);
      });
      this.correctLabel(false);
    },
    toogleTools(elem) {
      let tools = document.getElementsByClassName("all_form_block");
      let add = true;
      if (
        elem.target
          .closest(".all_form_block")
          .classList.contains("active")
      ) {
        add = false;
      }
      Array.prototype.slice.call(tools).forEach(element => {
        element.classList.remove("active");
      });
      if (add) {
        elem.target.closest(".all_form_block").classList.add("active");
      }
      this.correctLabel(false);
    },
    correctLabel(elem = true) {
      this.combined.forEach(element => {
        if (!element.value.trim()) {
          element.closest(".div_relative").classList.remove("active");
        } else {
          element.closest(".div_relative").classList.add("active");
        }
      });

      if (elem) {
        elem.target.closest(".div_relative").classList.add("active");
      }
    },
    langDatepicker(lang) {
      switch (lang) {
        case 'ru':
          return this.ru;
        case 'en':
          return this.en;
        case 'am':
          return this.am;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/components/pages/cv/tools-functions.js